import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Icon } from '@/presentation/components';
import { HeaderInfo } from '@/presentation/reusables/Wrapper/styled';
import { SubIcon as SubIcons } from '../../modules/scholarships/bse/home/Components/bseStyle';
import moneyIcon from '../../../../../assets/icons/icon-money.svg';
import calendarIcon from '../../../../../assets/icons/icon-calendar.svg';

const ProcedureHeader: React.FC<any> = (props) => {
  const {
    name,
    amount,
    duration,
    date,
    twoLineFormat,
    inRegister,
    star,
    additionalItem,
    paddingData = 0,
    paddingBottomData = 0,
    perPeriod = false
  } = props;
  return (
    <Block
      data-testid="cmp-certificateHeader"
      customized
      justifyContent="flex-start"
    >
      {name && (
        <Heading
          text={name}
          level={2}
          color="var(--text-text02)"
          size={18}
          lineHeight={isMobile ? 28 : 24}
          fontWeight="900"
          className=""
          align="flex-start"
        />
      )}
      {amount && (
        <Block
          customized
          flexDirection="column"
          alignItems="flex-start"
          margin={`${paddingData}px 0px ${paddingBottomData}px 0px`}
        >
          <HeaderInfo isTwo={!date}>
            <SubIcons>
              <img src={moneyIcon} alt="IconPushpin" />
              <p style={{ width: 'max-content' }}>
                {amount > 0 ? (
                  <div style={{ color: '#161D1F' }}>
                    Costo:{' '}
                    <b style={{ fontWeight: 900 }}>
                      S/ {amount}.00{star}
                    </b>{' '}
                    {perPeriod && (
                      <span style={{ color: '#4f6168' }}>por ciclo</span>
                    )}
                  </div>
                ) : (
                  <>Sin costo</>
                )}
              </p>
            </SubIcons>
            {duration && (
              <SubIcons>
                <Icon name="clock" size={16} />
                <p
                  style={{
                    fontSize: 14,
                    width: 'max-content'
                  }}
                >
                  {duration}
                </p>
              </SubIcons>
            )}
            {date && (
              <SubIcons>
                <img className="PR" src={calendarIcon} alt="IconCalendar" />
                <p style={{ color: 'var(--text-text02)' }}>
                  Fecha límite: {date?.toLowerCase() || ''}
                </p>
              </SubIcons>
            )}
          </HeaderInfo>
          {additionalItem && (
            <div style={{ marginTop: 8, width: '100%' }}>{additionalItem}</div>
          )}
        </Block>
      )}
      {twoLineFormat && !inRegister && <div style={{ marginBottom: '12px' }} />}
    </Block>
  );
};

export default ProcedureHeader;
